import React,{FC, useEffect, useState} from "react";
import Collapse from '@mui/material/Collapse';
import { UseTranslationContext } from '../Context/TranslationContext';

const Footer: FC = () => {
    const { currentLanguage, getKeyFromKeyId } = UseTranslationContext();
    const [isFooterActive, setIsFooterActive] = useState(false);
    const toggleFooter = () => setIsFooterActive(!isFooterActive);
    const GetTermsUrl = () => `https://groups.be/${currentLanguage == "nl" ? "nl" : "fr"}/disclaimer`;
    const GetContactUrl = () => `https://groups.be/${currentLanguage == "nl" ? "nl" : "fr"}/contact`;
    const getToggleSectionStyle = (isActive: boolean) => {
        let style = "image w-button section-toggle";
        if (isActive) style += " open";
        return style;
    };

    const getFooterStyle = (isActive: boolean) => {
        let style = "footer-container";
        if (isActive) style += " open";
        return style;
    };

    return (
        <>
            <footer id="footer" className="footer wf-section no-print">
                <button aria-label={getKeyFromKeyId("FOOTER_ICON_ALT")} onClick={(e) => toggleFooter()} className={getToggleSectionStyle(isFooterActive)}>Open Footer</button>
                <Collapse in={isFooterActive} easing="ease-in-out" timeout={500}>
                    <div role="navigation" className={getFooterStyle(isFooterActive)}>
                        <div className="footer-container-links">
                            <ul role="list" className="list-2 w-list-unstyled">
                                <li className="item-list-footer"><a href={GetTermsUrl()} target="_blank" className="alinkFooter">{getKeyFromKeyId('FOOTER_TERMS')}</a></li>
                                <li className="item-list-footer"><a href={GetContactUrl()} target="_blank" className="alinkFooter">{getKeyFromKeyId('FOOTER_CONTACT')}</a></li>
                            </ul>
                            <p className="paragraph-footer-3">
                                {getKeyFromKeyId('FOOTER_COPYRIGHT')} {getKeyFromKeyId('FOOTER_LAW')}
                                <br />
                                {`${getKeyFromKeyId('VERSION')} ${process.env.REACT_APP_VERSION}`}
                            </p>
                        </div>
                        <div id="w-node-_0149a32c-4e79-2706-6e23-207ccd85a797-cd85a781" className="link-website-2">
                                <p className="paragraph-footer-3">
                                    <a href={getKeyFromKeyId('URL_PORTAIL')} className="alinkFooter">{getKeyFromKeyId("PORTAL")}</a>
                                </p>
                                <img src="images/ic-launch-celeste.svg" loading="lazy" width="24" height="24" alt="icon to another site" className="icon-portail"/>
                        </div>
                    </div>
                </Collapse>
            </footer>
        </>
    )
}

export default Footer;